import { Text, View } from '@react-pdf/renderer'
import { PerformanceProcessPrintableAgreementConclusionsFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { Section, SectionTitle } from './_Blocks'

export const Conclusions: React.FC<{
  agreement: PerformanceProcessPrintableAgreementConclusionsFragment
}> = ({ agreement }) => {
  const actionItems = agreement.actionItemsInfo.map((action_item) => action_item.text)

  return (
    <>
      {agreement?.conclusions && (
        <Section>
          <SectionTitle>{i18n.t('performance_process.agreements.conclusions.title')}</SectionTitle>
          {agreement.conclusions.text
            .trim()
            .split('\n')
            .map((paragraph, index) => (
              <Text key={index} style={{ marginVertical: '5px' }}>
                {paragraph}
              </Text>
            ))}
        </Section>
      )}
      {actionItems != null && actionItems.length && (
        <Section>
          <SectionTitle>{i18n.t('performance_process.agreements.action_items.title')}</SectionTitle>
          {actionItems.map((paragraph, index) => (
            <View
              wrap={false}
              key={index}
              style={{ display: 'flex', flexDirection: 'row', marginVertical: '5px' }}
            >
              <Text style={{ fontWeight: 'bold', width: '20' }}>{index + 1}. </Text>
              <Text>{paragraph}</Text>
            </View>
          ))}
        </Section>
      )}
    </>
  )
}
